import { Check, ArrowRight } from "lucide-react";
import { WA_LINK } from "./shared";

export default function PackagesSection({ t }) {
  return (
    <section id="packages" className="relative bg-[#0A0807] py-16 sm:py-24 lg:py-32 overflow-hidden" data-testid="weddings-packages">
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none"
           style={{ backgroundImage: "radial-gradient(#D4B896 0.5px, transparent 0.5px)", backgroundSize: "26px 26px" }} />
      <div className="absolute top-1/4 -right-40 w-[500px] h-[500px] rounded-full bg-[#C9A87C]/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-10">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.35em] text-[#D4B896] mb-3 sm:mb-4 font-light">{t.packagesEyebrow}</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-white leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
            {t.packagesTitle} <span className="italic text-[#D4B896]">{t.packagesTitleAccent}</span>
          </h2>
          <p className="text-sm sm:text-base text-white/60 font-light mt-4 sm:mt-5 max-w-2xl mx-auto leading-relaxed">{t.packagesSubtitle}</p>
          <div className="w-12 sm:w-16 h-px bg-[#C9A87C] mx-auto mt-5 sm:mt-6" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-8">
          {t.packages.map((p, i) => (
            <div key={i}
                 className={`relative p-6 sm:p-8 lg:p-10 rounded-sm transition-all duration-500 ${p.highlighted
                   ? "bg-gradient-to-br from-[#D4B896] to-[#B8966F] text-[#0A0807] lg:-translate-y-3 shadow-[0_20px_60px_-15px_rgba(212,184,150,0.4)] border border-[#D4B896]"
                   : "bg-white/[0.04] backdrop-blur-sm border border-white/10 hover:border-[#C9A87C]/60 hover:bg-white/[0.07]"}`}
                 data-testid={`weddings-package-${i}`}>
              {p.highlighted && (
                <div className="absolute -top-3 left-6 sm:left-8 px-3 py-1 bg-[#0A0807] text-[#D4B896] text-[10px] tracking-[0.25em] font-medium rounded-sm">
                  POPULAR
                </div>
              )}
              <p className={`text-[11px] tracking-[0.25em] mb-1 ${p.highlighted ? "text-[#0A0807]/70" : "text-[#D4B896]"}`}>{p.tagline}</p>
              <h3 className={`text-xl sm:text-2xl font-medium mb-3 sm:mb-4 ${p.highlighted ? "text-[#0A0807]" : "text-white"}`}>{p.name}</h3>
              <div className={`text-3xl sm:text-4xl mb-4 sm:mb-5 ${p.highlighted ? "text-[#0A0807]" : "text-[#D4B896]"}`}
                   style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>{p.priceFrom}</div>
              <p className={`text-sm font-light leading-relaxed mb-5 sm:mb-6 ${p.highlighted ? "text-[#0A0807]/75" : "text-white/65"}`}>{p.description}</p>

              <div className={`h-px mb-5 sm:mb-6 ${p.highlighted ? "bg-[#0A0807]/15" : "bg-white/10"}`} />

              <ul className="space-y-2 sm:space-y-2.5 mb-6 sm:mb-8">
                {p.features.map((f, j) => (
                  <li key={j} className={`flex items-start gap-2 text-sm font-light ${p.highlighted ? "text-[#0A0807]/85" : "text-white/85"}`}>
                    <Check className={`w-4 h-4 mt-0.5 shrink-0 ${p.highlighted ? "text-[#0A0807]" : "text-[#D4B896]"}`} />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
                 className={`inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-3.5 text-[11px] tracking-[0.2em] sm:tracking-[0.25em] font-medium transition rounded-sm w-full ${p.highlighted
                   ? "bg-[#0A0807] hover:bg-black text-[#D4B896]"
                   : "border border-[#D4B896]/50 text-[#D4B896] hover:bg-[#D4B896] hover:text-[#0A0807] hover:border-[#D4B896]"}`}>
                {t.ctaPrimary} <ArrowRight className="w-3 h-3" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
